import getCDNIconUrl from './getCDNIconUrl';

export function getCloudCDNIcon(): string {
    return getCDNIconUrl('cloud_blue_16x16');
}
